import { render } from "./Dict.vue?vue&type=template&id=9fda2ee4"
import script from "./Dict.vue?vue&type=script&lang=ts"
export * from "./Dict.vue?vue&type=script&lang=ts"

import "./Dict.vue?vue&type=style&index=0&id=9fda2ee4&lang=less"
script.render = render

export default script